import React, { useEffect, useRef } from "react";

type Props = {
  html: string;
};

export function RenderHtml({ html }: Props) {
  const ref = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (!ref.current) return;
  //   ref.current.outerHTML = html;
  // }, []);

  return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}
